import { AccountDeliveryOption } from "../accountDeliveryOption/types";
import { Address, MapPosition, Phone } from "../common";

/**
 * Entidad AccountBranch
 * Representa una sucursal de una cuenta.
 */

export interface AccountBranch {
  id: string;
  accountId: string;
  name: string;
  address?: Address;  
  addressInstructions?: string;
  phone?: Phone | null;
  email?: string | null;
  demo:boolean;
  status: AccountBranchStatus; 
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;

  schedule: AccountBranchSchedule[];
  deliveryOptions: AccountDeliveryOption[];
}

export enum AccountBranchStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE"
}

 
export interface AccountBranchSchedule {
  id: string;
  accountBranchId: string;
  day: AccountBranchScheduleDay;
  start: number;
  end: number;
  status: AccountBranchScheduleStatus;
  demo:boolean;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;
}

export enum AccountBranchScheduleStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE"
}

export enum AccountBranchScheduleDay {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY"
}